import { call, put } from "redux-saga/effects";
import { TFASetupResponse } from "reduxStore/dataTypes";
import {
  twoFASetupSuccess,
  twoFASetupFailure,
} from "../reducers/twoFASetupReducer";
import { fetch2FACode } from "services/apiService";

function* twoFASetupSaga(): Generator<any, void, TFASetupResponse | any> {
  try {
    let response = yield call(fetch2FACode);

    yield put(twoFASetupSuccess(response.data));
  } catch (error: any) {
    if (error && error.response) {
      yield put(twoFASetupFailure(error.response));
    } else {
      yield put(twoFASetupFailure(error.message));
    }
  }
}

export default twoFASetupSaga;
